import React, { useMemo } from 'react';
import { Alert } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';

import { PriceChangeRequestAction } from '../../codegen/graphql';
import { useAuthStore } from '../../stores/auth.store';
import { useRequestDrawer } from '../../context/RequestDrawerContext';

function StandInRequest() {
    const { userId, standInForUserIds } = useAuthStore();
    const { actions } = useRequestDrawer();

    const allResponsibleUserIds = useMemo(
        () => [userId, ...standInForUserIds],
        [userId, standInForUserIds],
    );

    const myAction = useMemo(() => {
        return actions.find(
            (action: PriceChangeRequestAction) =>
                allResponsibleUserIds.includes(action.responsibleUser?.id) &&
                !action?.completed,
        );
    }, [actions, allResponsibleUserIds]);

    if (
        !myAction ||
        myAction?.completed ||
        myAction?.responsibleUser?.id === userId
    ) {
        return null;
    }

    return (
        <Alert
            icon={<IconAlertTriangle size="1rem" />}
            title="Stand-In Request"
            color="yellow"
            className="mb-5"
            radius="md"
        >
            You received this request because you standing in for{' '}
            <strong>
                {myAction.responsibleUser?.firstName}{' '}
                {myAction.responsibleUser?.lastName}
            </strong>
            .
        </Alert>
    );
}

export default StandInRequest;
